import React from 'react';
import ScaleLoader from 'react-spinners/ScaleLoader';
import { motion, AnimatePresence } from 'framer-motion';

const LoadingSpinner = (props) => {
  const spinnerStyle = {
    display: 'block',
    margin:'0 auto',
    textAlign: 'center'
  };
  return (
    <AnimatePresence>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        <ScaleLoader color={'#b580d1'} loading={true} css={spinnerStyle} height={50} />
      </motion.div>
    </AnimatePresence>
  );
};

export default LoadingSpinner;
